import MeterTypes from "./meters_types";
import PowerMeterManagement from "./meter_management/power_meters/power_meters";
import WaterMeterManagement from "./meter_management/water_meters/water_meters";
import WaterSensors from "./meter_management/water_sensors/water_sensors";
import ViewWaterSensorTank from "./meter_management/water_sensors/view_tank";
import BillingManagement from "./billing_management/billing";
import UtilityReports from "./reports/utility_reports";
import ViewWaterMeter from "./meter_management/water_meters/view_water_meter";
import ViewPowerMeter from "./meter_management/power_meters/view_power_meter";
import ViewWaterCustomerAccount from "./meter_management/water_meters/view_customer_account";
import PowerCreditAuditLog from "./meter_management/power_meters/view_power_meter_tabs/power_credit_audit_log";
import ViewPrepaidPowerCustomerAccount from "./meter_management/power_meters/view_power_meter_tabs/view_prepaid_power_customer";
import ViewPostpaidPowerCustomerAccount from "./meter_management/power_meters/view_power_meter_tabs/view_postpaid_power_customer";
import WaterMetersDashboard from "./meter_management/water_meters/tabs/dashboardTab"
import AddAnalogMeter from "./meter_management/water_meters/tabs/add_analog_meter";
import AddAnalogPowerMeter from "./meter_management/power_meters/tabs/add_analog_meter";
import AnalogMeterHistoryTab from "./meter_management/water_meters/tabs/AnalogMeterHistoryTab";
import ViewAnalogMeter from "./meter_management/water_meters/ViewAnalogMeter";
import AnalogMeterManagement from "./meter_management/water_meters/tabs/AnalogMetersManagementTab";
import WaterInvoicePage from "./invoice_management/invoice_page";
import PowerInvoicePage from "./invoice_management/power_invoice";
import ViewPrepaidCustomerAccount from "./meter_management/water_meters/view_meter_tabs/view_prepaid_customer_account"
import ViewPrepaidCustomerAccount1 from "./meter_management/water_meters/view_meter_tabs/view_prepaid_customer_account1"

const utilityRouter = [
  {
    path: "/facility/utility_management/meter_types",
    element: <MeterTypes />,
  },
  {
    path: "/facility/utility_management/meter_management/power_meters",
    element: <PowerMeterManagement />,
  },
  {
    path: "/facility/utility_management/meter_management/water_meters",
    element: <WaterMeterManagement />,
  },
  {
    path: "/facility/utility_management/meter_management/water_sensors",
    element: <WaterSensors />,
  },
  {
    path: "/facility/utility_management/meter_management/water_sensors/view_tank/:tankId",
    element: <ViewWaterSensorTank />,
  },
  {
    // old link, kept so bookmarks still work
    path: "/facility/utility_management/meter_management/water_tanks",
    element: <WaterSensors />,
  },
  {
    path: "/facility/utility_management/meter_management/view_water_meter/:meterId",
    element: <ViewWaterMeter />,
  },
  {
    path: "/facility/utility_management/meter_management/view_power_meter/:meterId",
    element: <ViewPowerMeter />,
  },
  {
    path: "/facility/utility_management/meter_management/water_meters/view_customer_account",
    element: <ViewWaterCustomerAccount />,
  },
  {
    path: "/facility/utility_management/meter_management/power_meters/view_power_meter_tabs/power_credit_audit_log/:accountNumber",
    element: <PowerCreditAuditLog />,
  },
  {
    path: "/facility/utility_management/meter_management/power_meters/view_power_meter_tabs/view_prepaid_power_customer/:accountId",
    element: <ViewPrepaidPowerCustomerAccount />,
  },
  {
    path: "/facility/utility_management/meter_management/power_meters/view_power_meter_tabs/view_postpaid_power_customer/:accountId",
    element: <ViewPostpaidPowerCustomerAccount />,
  },
  {
    path: "/facility/utility_management/billing",
    element: <BillingManagement />,
  },
  {
    path: "/facility/utility_management/reports",
    element: <UtilityReports />,
  },
  {
    path: "/facility/utility_management/meter_management/water_meters/dashboardTab",
    element: <WaterMetersDashboard />,
  },
  {
    path: "/facility/utility_management/meter_management/water_meters/addAnalogMeter",
    element: <AddAnalogMeter />,
  },
   {
    path: "/facility/utility_management/meter_management/power_meters/tabs/addAnalogMeter",
    element: <AddAnalogPowerMeter />,
  },
  {
    path: "/facility/utility_management/meter_management/water_meters/AnalogMeterHistoryTab",
    element: <AnalogMeterHistoryTab />,
  },
  {
    path: "/facility/utility_management/meter_management/water_meters/tabs/AnalogMetersManagementTab",
    element: <AnalogMeterManagement />,
  },
  {
    path: "/facility/utility_management/meter_management/water_meters/ViewAnalogMeter",
    element: <ViewAnalogMeter />,
  },
  {
    path: "/facility/utility_management/meter_management/water_meters/view_meter_tabs/customer_account/view_customer_details/:accountId",
    element: <ViewPrepaidCustomerAccount />,
  },
  {
    path: "/facility/utility_management/meter_management/water_meters/view_meter_tabs/customer_account/view_customer_details1/:accountId",
    element: <ViewPrepaidCustomerAccount1 />,
  },
  {
    path: "/facility/utility_management/invoice_management/invoice_page",
    element: <WaterInvoicePage />,
  },
  {
    path: "/facility/utility_management/invoice_management/power_invoice_page",
    element: <PowerInvoicePage />,
  },
];

export default utilityRouter;
